import {lm} from "../../appContext";
import {SyncstepId} from "../../constants/Syncstep";
import {convertFromServerString} from "../../util/datetime";

export namespace nsPassword {

    export function parseServerDate(serverDate: string): number | null {
        if (!serverDate) return null
        const m = convertFromServerString(serverDate)
        if (!m || !m.isValid()) return null
        return m.valueOf()
    }
    

    export function resolveSyncstepName(
        sourceId: number | null,
        serverSyncstepName: string | undefined,
        fallbackTargetSystem: string,
    ): string {
        // Translation lookup wins when the customer has localised the syncstep
        // name (`syncstep.name.<id>` lives in SyncFieldDisplayName).
        // We pass `desc: true` so that, *only on the password progress page*,
        // the syncfield's description is preferred over the displayname. This
        // lets admins configure a friendlier "what is this integration" label
        // (e.g. "Microsoft 365 (work account)") that surfaces here without
        // affecting the syncstep name shown anywhere else in the product.
        if (sourceId !== null && sourceId > 0) {
            const key = 'syncstep.name.' + sourceId;
            if (lm.hasTranslation(key)) {
                return lm.t({k: key, desc: true}) ?? '';
            }
        }
        // Otherwise show the actual configured CompanySyncStep.SyncStep.Name
        // returned by the BE — this is what an admin would see in the sync
        // configuration UI and is the most meaningful label for the user.
        if (serverSyncstepName) {
            return serverSyncstepName;
        }
        if (sourceId !== null && sourceId > 0) {
            const enumName = SyncstepId[sourceId];
            if (enumName) {
                return enumName.replace(/_/g, ' ');
            }
        }
        return fallbackTargetSystem || '';
    }

}
